import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class SameHeroes extends Request {
  constructor() {
    super()
  }

  get path() {
    return '/json/same-character.json'
  }

  get method() {
    return Methods.get
  }

  decode({ data }) {
    const _data = []
    for (let key in data) {
      const item = {}
      item[key] = data[key].map((d) => {
        const hero = new ModelHero(d)
        return hero
      })
      _data.push(item)
    }
    return _data
  }

  decodeError(error) {
    return { error: error }
  }
}
